import Vue from 'vue';

import apiFactory from '@/api/default';

const API = apiFactory('compositetasks');

const state = {
  compositeTaskSearchResults: [],
  currentCompositeTask: {},
};

const getters = {
  compositeTaskSearchResults: (state) => state.compositeTaskSearchResults,
  currentCompositeTask: (state) => state.currentCompositeTask,
};

const mutations = {
  setCompositeTaskSearchResults: (state, compositeTaskSearchResults) => {
    state.compositeTaskSearchResults = compositeTaskSearchResults;
  },
  updateCompositeTaskSearchResults: (state, task) => {
    const index = state.compositeTaskSearchResults.findIndex((el)=>el._id === task._id);
    if (index >= 0) Vue.set(state.compositeTaskSearchResults, index, task);
  },
  removeFromCompositeTaskSearchResults: (state, id)=>{
    state.compositeTaskSearchResults.data = state.compositeTaskSearchResults.filter((obj)=>{
      return obj._id !== id;
    });
    state.compositeTaskSearchResults.total--;
  },
  setCurrentCompositeTask: (state, currentCompositeTask) => {
    state.currentCompositeTask = currentCompositeTask;
  },
};

const actions = {
  async searchCompositeTasks({commit}, payload) {
    const response = await API.search(payload.query, payload.headers);
    if (response) {
      if (payload.opts?.setResultsInStore) {
        commit('setCompositeTaskSearchResults', response.data);
      }
      return response.data;
    }
  },
  async loadCompositeTask({commit}, payload) {
    const response = await API.load(payload.id, payload.headers);

    commit('setCurrentCompositeTask', response.data);
    return response.data;
  },
  async createCompositeTask({commit}, payload) {
    const response = await API.create(payload.data, payload.headers);
    return response.data;
  },
  async updateCompositeTask({commit}, payload) {
    const response = await API.update(payload.id, payload.data, payload.headers);
    commit('updateCompositeTaskSearchResults', response.data);
    return response.data;
  },
  async deleteCompositeTask({commit}, payload) {
    const response = await API.remove(payload.id, payload.headers);
    commit('removeFromCompositeTaskSearchResults', payload.id);
    return response;
  },
  async renderImages({commit}, data) {
    const response = await API.create(data);
    return response.data;
  },
  async startTraining({commit}, data) {
    const response = await API.create(data);
    return response.data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
